import { module } from 'modujs';
import { gsap } from 'gsap'; 

let xml = `<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 482 332" style="enable-background:new 0 0 483 332;" width="483" height="332" xml:space="preserve"> <g> <path d="M382.9,47.8c14.5-2.4,22.1-11.1,23-25.9c0.9-16.8-4.4-22.3-21.9-21.5l0,0c-9.8-2.1-17.4,4.3-25.7,8.8 c-7.1,3.9-10.9,15.5-7.4,22.7C356,42.7,370.6,49.9,382.9,47.8z"/> <path d="M2.1,208.1c-3,3.2-2.8,8.3,0.4,11.3c3.2,3,8.3,2.8,11.4-0.4l0,0l0.1-0.1l0.3-0.3c0.2-0.2,0.6-0.6,1-1.1 c0.9-0.9,2.2-2.3,4-4.1c1.2-1.2,2.5-2.5,4-4c59.4-25.8,133.3-31.4,204.6-27.1c-45.7,2.5-91.4,13-127.2,23.5 c-21.2,6.2-39,12.4-51.6,17.1c-6.3,2.3-11.3,4.3-14.7,5.7c-1.7,0.7-3,1.2-3.9,1.6c-0.4,0.2-0.8,0.3-1,0.4h-0.1 c-2.3,0.9-4.1,2.8-4.8,5.3c-1.1,3.8,0.8,7.8,4.4,9.5l0,0l0,0l0,0l0.4,0.2c0.3,0.1,0.7,0.3,1.3,0.6c1.1,0.5,2.7,1.2,4.9,2.2 c4.2,1.9,10.3,4.6,17.9,7.9c15.1,6.6,36.1,15.6,59.7,25.1c46.8,18.8,104.4,39.9,145.2,47.5c66.7,12.5,122.6-10.5,161.4-36.1 c19.4-12.8,34.7-26.4,45.2-36.8c5.2-5.2,9.3-9.6,12-12.7c1.4-1.6,2.4-2.8,3.1-3.7c0.4-0.4,0.6-0.8,0.8-1c0.1-0.1,0.2-0.2,0.2-0.3 l0.1-0.1l0,0l0,0l0,0l0,0c2.2-2.8,2.2-6.5,0.4-9.3l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0-0.1-0.1-0.1-0.1-0.2l-0.1-0.1 c-0.1-0.2-0.3-0.5-0.5-0.8c-0.5-0.7-1.2-1.8-2.1-3.1c-1.8-2.7-4.5-6.5-7.8-11.1c-6.7-9.3-16.3-21.8-27.6-35 c-22.4-26-53.2-56-83.9-66.7c-32.1-11.1-60.1,1.4-79.1,15.6c-9.6,7.1-17.2,14.9-22.4,20.8c-0.7,0.7-1.3,1.5-1.9,2.1 c-1.9-1.9-4.2-4.2-7-6.7c-10.3-9.2-27.5-22.3-55.8-38.6c-17.3-10-38.7-6.5-58.9,1.8c-20.5,8.4-42,22.6-61.4,37.5s-37,30.8-49.7,43 c-6.4,6.1-11.5,11.2-15.1,14.9c-1.8,1.8-3.2,3.3-4.1,4.3c-0.5,0.5-0.8,0.9-1.1,1.1L2.7,208L2.1,208.1L2.1,208.1 M105.1,221.2 c41.6-12.2,95.7-24,146.8-23.4c51.7,0.6,101.4,7.4,140.8,16c19.3,4.2,36,8.8,49.1,13.3c-25.6,15.2-153.9,14.5-236.6,16.9 c-6.3-0.3-12.5-0.5-18.6-0.9c-42.7-2.2-81.1-5.4-108.9-8.1c-4.3-0.4-8.3-0.8-12-1.2C76.7,230.1,90,225.6,105.1,221.2z M32.1,238.2 L32.1,238.2L32.1,238.2L32.1,238.2L32.1,238.2z"/> </g> </svg>`

export default class extends module {
    constructor(m) {
        super(m);

        this.canvas = this.$('canvas')[0];
        this.ctx = this.canvas.getContext('2d');

        this.mouths = this.getData('mouths').split(',');

        this.bindResize = this.resize.bind(this);
        window.addEventListener('resize',this.bindResize);

        this.imgRatio = 332 / 483
    }

    init() {
        this.resize();

        this.tl = gsap.timeline();
        this.tl.pause();

        this.mainData = {
            width: 0,
            height: 0,
            x: 0.5,
            y: 0.5,
            ratio: 332 / 483
        };

        if(!window.isMobile && !window.isTablet) {
            this.tl.fromTo(this.mainData, {
                width: 8,
                x: -0.2,
                y: -0.3
            }, {
                width: 0.4,
                x: 0.5,
                y: 0.6,
                duration: 1
            });
        } else {
            this.tl.fromTo(this.mainData, {
                width: 50,
                x: -0.2,
                y: -2.2
            }, {
                width: 0.4,
                x: 0.5,
                y: 0.6,
                duration: 1
            });
        }
        
        // table of other mouths
        this.decorations = Array.from(new Array(7)).map((item, index) => {

            let style = {
                img: 'main',
                x: 0, 
                y: 0.2,
                width: 0,
                height: 0,
                rotate: 0
            }

            if(index == 0) {
                this.tl.fromTo(style, {
                    width: 0.4,
                    x: -0.5,
                    y: 0,
                    rotate: 90
                }, {
                    width: 0.08,
                    x: 0.1,
                    y: 0.2,
                    rotate: -5,
                    duration: 1,
                },'<+=0.3');
            }

            if(index == 1) {
                this.tl.fromTo(style, {
                    width: 0.6,
                    x: 2,
                    y: 0,
                    rotate: 40
                }, {
                    width: 0.15,
                    x: 0.8,
                    y: 0.4,
                    rotate: -10,
                    duration: 1,
                },`<+=0.15`);
            }
            if(index == 2) {
                this.tl.fromTo(style, {
                    width: 0.5,
                    x: -0.8,
                    y: 1,
                    rotate: -50
                }, {
                    width: 0.12,
                    x: 0.15,
                    y: 0.5,
                    rotate: 10,
                    duration: 1,
                },`<+=0.15`);
            }

            if(index == 3) {
                this.tl.fromTo(style, {
                    width: 0.5,
                    x: 1.2,
                    y: 1.2,
                    rotate: 50
                }, {
                    width: 0.12,
                    x: 0.75,
                    y: 0.85,
                    rotate: -15,
                    duration: 1,
                },`<+=0.15`);
            }

            if(index == 4) {
                this.tl.fromTo(style, {
                    width: 0.4,
                    x: 0.4,
                    y: -0.5,
                    rotate: -10
                }, {
                    width: 0.09,
                    x: 0.4,
                    y: 0.15,
                    rotate: 10,
                    duration: 1,
                },`<+=0.15`);
            }

            if(index == 5) {
                this.tl.fromTo(style, {
                    width: 0.4,
                    x: 0.3,
                    y: 1.2,
                    rotate: 40
                }, {
                    width: 0.08,
                    x: 0.3,
                    y: 0.8,
                    rotate: 10,
                    duration: 1,
                },`<+=0.15`);
            }

            if(index == 6) {
                this.tl.fromTo(style, {
                    width: 0.4,
                    x: 1.4,
                    y: 0.6,
                    rotate: 10
                }, {
                    width: 0.09,
                    x: 0.9,
                    y: 0.6,
                    rotate: -15,
                    duration: 1,
                },`<+=0.15`);
            }

            return style;
        });

                
        this.mainImg = new Image();
        this.mainImg.addEventListener('load', () => {
            this.mainImgLoaded = true;
            this.resize();
        });
        this.mainImg.src = 'data:image/svg+xml,' + escape(xml);;

        this.secondaryImg = new Image();
        this.mainImg.addEventListener('load', () => {
            this.secondaryImgLoaded = true;
            this.resize();
        });
        this.secondaryImg.src = 'data:image/svg+xml,' + escape(xml);;

        gsap.delayedCall(1, () => {
            this.resize();
        })
    }

    draw() {
        if(!this.mainImgLoaded || !this.secondaryImgLoaded) return;

        this.ctx.globalCompositeOperation='source-over';
        this.ctx.clearRect(0,0,this.canvas.width, this.canvas.height);
        this.ctx.fillStyle = '#E7BEAF';
        this.ctx.fillRect(0,0,this.canvas.width, this.canvas.height);

        this.ctx.globalCompositeOperation='destination-out';

        let mainImgWidth = this.mainData.width * this.unit;
        this.mainData.height = this.mainData.width * this.imgRatio;

        let mainImgHeight = mainImgWidth * this.imgRatio;
        
        this.ctx.drawImage(
            this.mainImg, 
            (this.canvas.width * this.mainData.x) - mainImgWidth/2,
            (this.canvas.height * this.mainData.y) - mainImgWidth/2,
            mainImgWidth, 
            mainImgHeight
        );
        
        this.decorations.forEach((item, index) => {
            let imgWidth = item.width * this.unit;
            item.height = item.width * this.imgRatio;
            let imgHeight = imgWidth * this.imgRatio;

            let x = (this.canvas.width * item.x) - imgWidth/2;
            let y = (this.canvas.height * item.y) - imgHeight/2;
            
            this.ctx.translate(x,y);
            this.ctx.rotate(item.rotate * Math.PI / 180);

            this.ctx.drawImage(
                (item.img == 'main') ? this.mainImg : this.secondaryImg, 
                0,
                0,
                imgWidth, 
                imgHeight
            );
            this.ctx.rotate(-item.rotate * Math.PI / 180);
            this.ctx.translate(-x,-y);


        });
    }

    progress({progress, isReversed}) {
        let relativeProgress = progress;
        if(isReversed) relativeProgress = 1-progress;
        
        if(this.tl != undefined) {
            this.tl.progress(relativeProgress);
            this.draw();
        }
    }

    resize() {
        if(!window.isMobile || window.innerWidth != this.windowWidth) {
            this.windowWidth = window.innerWidth;

            this.w = this.el.getBoundingClientRect().width;
            this.h = this.el.getBoundingClientRect().height;

            this.unit = (this.w < this.h) ? this.w * 1.2 : this.h * 1.5;

            this.canvas.width = this.w;
            this.canvas.height = this.h;
            this.canvas.style.width = `${this.w}px`;
            this.canvas.style.height = `${this.h}px`;

            this.draw();
        }

    }
}
